<template>
    <div class="spinner-box" :style="{
        '--spinner-width': width + 'px',
        '--spinner-height': height + 'px',
        '--counter-spinner-width': width + 'px',
        '--counter-spinner-height': height + 'px',
        '--border-size': borderSize + 'px'
    }">
        <div class="spinner"></div>
        <div class="counter-spinner"></div>
    </div>
</template>

<script>
export default {
    props: {
        width: {
            type: Number,
            default: 120
        },
        height: {
            type: Number,
            default: 120
        },
        borderSize: {
            type: Number,
            default: 8
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.spinner-box {
    position: relative;
    display: inline-block;
    width: var(--spinner-width);
    height: var(--spinner-height);
}

.spinner,
.counter-spinner {
    position: absolute;
    border: var(--border-size) solid transparent;
    border-top-color: $dark-purple;
    border-left-color: $dark-purple;
    border-bottom-color: $dark-purple;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.spinner {
    width: calc(var(--spinner-width) * 0.66); // inner spinner smaller
    height: calc(var(--spinner-height) * 0.66);
    animation: spin 1.5s linear infinite;
}

.counter-spinner {
    width: var(--counter-spinner-width);
    height: var(--counter-spinner-height);
    animation: counter-spin 1.75s linear infinite;
}

@keyframes spin {
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}

@keyframes counter-spin {
    0% {
        transform: translate(-50%, -50%) rotate(360deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(0deg);
    }
}
</style>
